import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "files" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "grid col-span-3 gap-6 container-images sm:grid-cols-2 md:grid-cols-5 sm:gap-y-8 lg:gap-x-8"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 1,
    class: "flex items-center justify-center pt-5 mt-5"
};
const _hoisted_6 = { class: "text-2xl text-gray-400" };
import { FolderIcon, Link02Icon, SearchSmIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UITextSmMedium, renderIcon } from '@gohighlevel/ghl-ui';
import { computed, inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import TableView from '../components/TableView.vue';
import useContextMenu from '../composable/useContextMenu';
import useEmitter from '../composable/useEmitter';
import { useStore } from '../store';
import ContextMenu from './ContextMenu.vue';
import Accordion from './MediaAccordion.vue';
import PixabayFile from './PixabayFile.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PixabayImages',
    props: {
        images: { default: () => [] },
        searchText: { default: '' },
        category: { default: 'pixabay' },
        accordionVisible: { type: Boolean, default: false },
        mediaLayout: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const parentEmitter = inject('emitter');
        const emitter = useEmitter();
        const contextMenuItems = [
            {
                name: t('common.getLink'),
                slug: 'link',
                icon() {
                    return renderIcon(Link02Icon);
                },
            },
            {
                name: t('common.addImageToMedia'),
                slug: 'addPixabayImage',
                icon() {
                    return renderIcon(FolderIcon);
                },
            },
        ];
        const { $state, updateActiveExternalObject } = useStore();
        const activeItem = computed(() => $state.activeItem._id);
        function onSelectFile(image) {
            updateActiveExternalObject(image);
            emitter.emit('media-select-option', {
                file: image,
                fileType: 'external',
            });
        }
        const { contextMenuItemClick } = useContextMenu();
        const pixabayMenuRef = ref();
        function handleFileClick(event, item) {
            pixabayMenuRef.value.showMenu(event, item);
        }
        function onclickFileSelect(image) {
            parentEmitter.emit('media-center:attachment', { url: image.largeImageURL });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.searchText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(Accordion, {
                            showToggle: _ctx.accordionVisible,
                            open: true
                        }, {
                            title: _withCtx(() => [
                                (_ctx.mediaLayout === 'grid' || _ctx.category === 'all')
                                    ? (_openBlock(), _createBlock(_unref(UITextSmMedium), {
                                        key: 0,
                                        class: "text-gray-600"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Pixabay ")
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            content: _withCtx(() => [
                                (_ctx.mediaLayout === 'grid')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                                            return (_openBlock(), _createBlock(PixabayFile, {
                                                key: image.id,
                                                id: image.id,
                                                onClick: ($event) => (onSelectFile(image)),
                                                activeItem: activeItem.value,
                                                image: image,
                                                class: "h-100 image-item",
                                                onDblclick: ($event) => (onclickFileSelect(image)),
                                                onContextmenu: _withModifiers(($event) => (handleFileClick($event, image)), ["prevent", "stop"])
                                            }, null, 8, ["id", "onClick", "activeItem", "image", "onDblclick", "onContextmenu"]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(TableView, {
                                            id: "identifier.BlogList_Table",
                                            files: _ctx.images,
                                            type: "pixabay"
                                        }, null, 8, ["files"])
                                    ]))
                            ]),
                            _: 1
                        }, 8, ["showToggle"])
                    ]))
                    : (!_ctx.searchText && _ctx.category == 'pixabay')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_unref(SearchSmIcon), { class: "mr-2 text-gray-400 h-7 w-7" }),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('common.searchSomething')), 1)
                        ]))
                        : _createCommentVNode("", true),
                _createVNode(ContextMenu, {
                    elementId: 'pixabayMenu',
                    options: contextMenuItems,
                    ref_key: "pixabayMenuRef",
                    ref: pixabayMenuRef,
                    onOptionClicked: _unref(contextMenuItemClick)
                }, null, 8, ["onOptionClicked"])
            ]));
        };
    }
});
